import qs from 'qs';
import { parseInt, omit, values } from 'lodash/fp';
import { connect } from 'react-redux';
import {
  updateInventoryPackage,
  fetchInventoryPackage,
  fetchInventoryPackageItems,
  fetchInventoryPackageAvailability
} from '../../../../../redux/Inventory/sagas/routines';
import {
  getIsFetching,
  getIsSaving,
  getIsSaved,
  getPackageForId
} from '../../../../../redux/Inventory/selectors/package';
import {
  getAvailabilityForItemId,
  getIsFetchingByItem as getIsFetchingItemAvailability
} from '../../../../../redux/Inventory/selectors/package/availability';
import {
  getPackageItems,
  getIsFetchingPackageItems
} from '../../../../../redux/Inventory/selectors/components/item-form';

import { PackageType } from '../../../../../constants/inventory/InventoryTypes';
import AdjustItem from '../../component';

function mapStateToProps(state, { location, match: { params } }) {
  const { id } = params;
  const { action } = qs.parse(location.search, { ignoreQueryPrefix: true });
  return {
    action: parseInt(10, action),
    type: PackageType,
    item: getPackageForId(state, id),
    packageItems: values(getPackageItems(state, id)),
    availability: getAvailabilityForItemId(state, id),
    isFetchingItem: getIsFetching(state),
    isFetchingPackageItems: getIsFetchingPackageItems(state),
    isFetchingItemAvailability: getIsFetchingItemAvailability(state),
    isSaved: getIsSaved(state),
    isSaving: getIsSaving(state)
  };
}

function mapDispatchToProps(dispatch, { match: { params } }) {
  const { id } = params;
  return {
    onInit: () => {
      dispatch(fetchInventoryPackage(id));
      dispatch(fetchInventoryPackageItems(id));
      dispatch(fetchInventoryPackageAvailability(id));
    },
    onSubmit: body => {
      const omitProps = ['id', 'items', 'createdAt', 'updatedAt', 'deletedAt'];
      const payload = { id: body.id, body: omit(omitProps, body) };
      dispatch(updateInventoryPackage(payload));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdjustItem);
